import * as types from '../mutation-types'
import Evaluate from '../../resource/evaluate'
const state = {
  evaluates_map: new Map(), // 测评 集合
  evaluates: [], // 测评 集合
  current: {}, // 当前的测评
  record: null // 测评记录ID
}

const getters = {
  allEvaluates: state => state.evaluates,
  currentEvaluate: state => state.current,
  currentEvaluateRecord: state => state.record
}

const actions = {
  getEvaluateById: function ({
    commit,
    state
  }, id) {
    if (state.evaluates_map.has(id)) {
      commit(types.LOAD_EVALUATE, state.evaluates_map.get(id))
    } else {
      Evaluate.get(id, eva => {
        commit(types.LOAD_EVALUATE, eva)
      })
    }
  },
  setEvaluateRecord: function ({
    commit
  }, record) {
    commit(types.SET_RECORD_ID, record)
  },
  loadEvaluates: function ({
    commit
  }) {
    Evaluate.questionnaires(evas => {
      commit(types.LOAD_EVALUATES, evas)
    })
  }
}

const mutations = {
  [types.LOAD_EVALUATE](state, evaluate) {
    if (evaluate) {
      state.evaluates_map.set(evaluate._id, evaluate)
      state.evaluates = [...state.evaluates_map.values()]
    }
    state.current = evaluate
  },
  [types.SET_RECORD_ID](state, record) {
    state.record = record
  },
  [types.LOAD_EVALUATES](state, evas) {
    evas.forEach(eva => {
      state.evaluates_map.set(eva._id, eva)
    })
    state.evaluates = evas
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/evaluate.js